/** Logo de WulfTime: el lobo (sobre una placa blanca en fondos oscuros) y el nombre. */
export function Logo({ dark = false, size = 'md', showName = true }: { dark?: boolean; size?: 'sm' | 'md' | 'lg'; showName?: boolean }) {
  const box = size === 'lg' ? 'h-11 w-11' : size === 'sm' ? 'h-7 w-7' : 'h-9 w-9';
  return (
    <span className="inline-flex items-center gap-2.5">
      <span className={`${box} inline-flex shrink-0 items-center justify-center rounded-xl ${dark ? 'bg-white p-1 shadow-sm' : ''}`}>
        <img src="/brand/wulftime-mark.svg" alt="" className="h-full w-full object-contain" draggable={false} />
      </span>
      {showName && (
        <span className={`${size === 'lg' ? 'text-2xl' : size === 'sm' ? 'text-base' : 'text-lg'} font-semibold tracking-tight ${dark ? 'text-white' : 'text-brand-950'}`}>
          Wulf<span className={dark ? 'text-brand-300' : 'text-brand-600'}>Time</span>
        </span>
      )}
    </span>
  );
}
